import { PublicLocale, Locale, MobilityTranslations } from "../types"

export default class MobilityHelper {
  static getTranslation<T>(locale: Locale | PublicLocale, translations: MobilityTranslations<T>, property: keyof T, fallbackLocale?: Locale | PublicLocale): string {
    const localeTranslations = translations[locale || fallbackLocale]

    if (!localeTranslations) return ''

    return localeTranslations[property as string] || ''
  }

  static updateTranslation<T>(locale: Locale | PublicLocale, translations: MobilityTranslations<T>, property: keyof T, value: string): MobilityTranslations<T> {
    const updatedTranslations = { ...translations }

    updatedTranslations[locale as string] = updatedTranslations[locale] || {}
    updatedTranslations[locale][property as string] = value

    return updatedTranslations
  }
}